import makeStyles from '@mui/styles/makeStyles';
import { FormattedMessage } from 'react-intl';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const useStyles = makeStyles(({
  dialogContent: {
    padding: 28,
  },
  headerRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 14,
  },
  alertIcon: {
    flex: 'none',
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: '#FBECEB',
    border: '1px solid #F2CFCC',
    color: '#D14343',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontFamily: "'Inter Tight', sans-serif",
    fontSize: 20,
    fontWeight: 700,
    lineHeight: 1.2,
    letterSpacing: '-.01em',
    color: '#16141D',
    margin: 0,
  },
  description: {
    color: '#5F5D75',
    lineHeight: 1.55,
    fontSize: 13.8,
    margin: '7px 0 0',
  },
  btnContainer: {
    marginTop: 24,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    gap: 12,
  },
}));

interface CancelOrderDialogProps {
  showDialog: boolean,
  handleCancelOrder: () => void,
  handleCloseDialog: () => void,
}

const CancelOrderDialog = (props: CancelOrderDialogProps) => {
  const classes = useStyles();
  const {
    showDialog,
    handleCancelOrder,
    handleCloseDialog,
  } = props;

  return (
    <Dialog
      open={showDialog}
      id="cancel-order-dialog"
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '20px',
          border: '1px solid #E1E7E4',
          maxWidth: 480,
        },
      }}
    >
      <DialogContent id="cancel-order-dialog-content" className={classes.dialogContent}>
        <div className={classes.headerRow}>
          <span className={classes.alertIcon}>
            <ErrorOutlineIcon fontSize="small" />
          </span>
          <div>
            <p className={classes.title}>
              <FormattedMessage
                id="page.order.history.cancel.order.title"
              />
            </p>
            <p className={classes.description}>
              <FormattedMessage
                id="page.order.history.cancel.order.message"
              />
            </p>
          </div>
        </div>
        <div className={classes.btnContainer}>
          <Button
            id="keep-order-btn"
            onClick={handleCloseDialog}
            sx={{
              height: 44,
              padding: '0 20px',
              border: '1.5px solid #D7DBE0',
              borderRadius: '10px',
              backgroundColor: '#FFFFFF',
              color: '#16141D',
              fontSize: 14,
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                border: '1.5px solid #B7BCC4',
                backgroundColor: '#F6F8F7',
              },
            }}
          >
            <FormattedMessage
              id="page.order.history.cancel.order.keep"
            />
          </Button>
          <Button
            id="cancel-order-btn"
            onClick={handleCancelOrder}
            sx={{
              height: 44,
              padding: '0 22px',
              borderRadius: '10px',
              backgroundColor: '#D14343',
              color: '#FFFFFF',
              fontSize: 14,
              fontWeight: 600,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: '#B93A3A',
              },
            }}
          >
            <FormattedMessage
              id="page.order.history.cancel.order.cancel"
            />
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CancelOrderDialog;
